import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { getCurrentUser } from 'aws-amplify/auth'

import { get } from '@/services/awsAmplify'

import { Badge } from '@/enums'

export const useAccountInfo = (userId?: UUID, opts?: { enabled?: boolean }) =>
  useQuery({
    queryKey: ['account', userId].filter(Boolean),
    queryFn: getAccountInfo,
    ...opts,
  })

export interface AccountInfo {
  id: UUID
  xp: number
  rpk?: number
  multiplier?: number
  badge?: Badge
}

export const getAccountInfo = async ({
  queryKey,
}: UseQueryOptions): Promise<AccountInfo> => {
  const { username } = await getCurrentUser()
  const [, userId] = queryKey

  return get({
    path: `/accounts/${userId || username}`,
  })
}
